import axios from "axios";

const apiKey = `${process.env.REACT_APP_IMGBB_API_KEY}`;
const apiUrl = process.env.REACT_APP_IMGBB_API_URL;

const uploadImage = (image) => {
  const formData = new FormData();
  formData.append("image", image);
  formData.append("key", apiKey);

  return axios
    .post(apiUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response.data.data.display_url;
    })
    .catch((error) => {
      console.error(error);
    });
}

export default uploadImage;